import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const BusinessContext = createContext(null);

export function BusinessProvider({ children }) {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.get("/business").then((r) => setProfile(r.data)).catch(() => setProfile(false));
  }, []);

  return <BusinessContext.Provider value={{ profile, setProfile }}>{children}</BusinessContext.Provider>;
}

export const useBusiness = () => useContext(BusinessContext);
